import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { ESIM_SEND_QR_EMAIL } from "./actionTypes";
import { API_URL_SEND_EMAIL_WITH_QR } from "./api";
import { RootState } from "../../../../models";
import { post as Ajax_post } from "../../app/Ajax";

export const sendEmailWithQRCode =
    (orderGuid: string, email: string, iccid: string): ThunkAction<Promise<void>, RootState, unknown, AnyAction> =>
    async (dispatch) => {
        const payload = Ajax_post({
            url: API_URL_SEND_EMAIL_WITH_QR,
            data: {
                orderGuid,
                email,
                iccid,
            },
        });
        dispatch({
            type: ESIM_SEND_QR_EMAIL,
            payload,
        });

        return payload;
    };
